<template>
  <div v-if="council">
    <v-card max-width="480" :elevation="24" :loading="savingDonor">
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="4">
              <Logo :url="getCouncilImage" alt="Logo Benfeitores" height="65" width="185" />
            </v-col>
            <v-col cols="8">
              <h5 class="primary--text text-right">{{ council.entityViewModel.name }} <br>Sua doação é <br>muito
                importante para nós</h5>
            </v-col>
          </v-row>
        </v-container>

        <v-container>
          <v-form v-model="isDonorInformationValid">
            <div v-if="step == 1">
              <p class="mt-2">Por favor entre com seus dados para prosseguir:</p>
              <v-row>
                <v-col cols="12">
                  <v-text-field id="document" v-mask="['###.###.###-##']" v-model="donor.Document" label="CPF" outlined
                    hide-details="auto" required :rules="[validateDonorDocument]"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="donor.FullName" label="Nome" outlined hide-details="auto" required
                    :rules="[validateDonorFullName]"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="donor.Email" label="E-mail" outlined hide-details="auto" required
                    :rules="[validateDonorEmail]"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-combobox v-model="donor.PaymentMethod" :items="paymentMethods" item-text="Name" item-value="Id"
                    label="Metódo de pagamento" outlined hide-details="auto" required
                    :rules="[validateDonorPaymentMethod]"></v-combobox>
                </v-col>
              </v-row>
            </div>

            <div class="pa-0 ma-0" v-if="step == 2">
              <v-row>
                <v-col cols="12">
                  <v-combobox v-model="donor.Institution" :items="institutions" item-text="name" item-value="id"
                    return-object label="Escolha uma Instituição" outlined hide-details="auto" required
                    :rules="[validateInstitution]" :disabled="savingDonor"></v-combobox>
                </v-col>
                <v-col cols="12">
                  <!--                <h5>Valor da sua doação</h5>-->
                  <v-text-field id="amount" v-model="donor.Amount" v-money="money" label="Valor da doação"
                    placeholder="a partir de R$ 10,00" outlined hide-details="auto" required
                    :rules="[validateDonorAmount]"></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-divider class="lg"></v-divider>


                  <v-card-title v-if="donor.PaymentMethod.Id == 2">
                    Doação via transferência bancária
                  </v-card-title>
                  <v-card-title v-else>
                    {{ paymentMethodSelected }}
                  </v-card-title>

                  <template v-if="donor.PaymentMethod.Id == 1">
                    <v-card-text class="text--primary">
                      <div>Pague em qualquer em qualquer agência bancárias, na rede credenciada, nas lotéricas, por
                        Internet Banking, etc.</div>
                    </v-card-text>

                    <v-col cols="8">
                      <InputDueDate :rules="[validateDueDate]" v-model="donor.DueDate" label="Data de vencimento"
                        :disabled="false" />
                    </v-col>
                  </template>

                  <template v-if="donor.PaymentMethod.Id > 1">
                    <v-card-text class="text--primary pb-0">

                      <template v-if="donor.PaymentMethod.Id == 2">
                        <p>Você deve fazer uma transferência e enviar por aqui o comprovante:</p>

                        <div><b class="text--secondary">{{ council.entityViewModel.socialReason }}</b><br></div>
                        <div><b>Agência:</b> {{ council.agency }} / Banco do Brasil</div>
                        <div><b>Conta Corrente:</b> {{ council.account }}-{{ council.digit }}</div>
                        <div><b>CNPJ:</b> {{ council.entityViewModel.document }}</div>
                        <div><b>Chave PIX:</b> {{ council.entityViewModel.document }}</div>
                        <br>
                      </template>

                      <template v-if="donor.PaymentMethod.Id == 3">
                        <div>A partir do <b>Programa de IRPF da Receita Federal</b>, gere o DARF com o valor informado,
                          faça o pagamento e <b>anexe aqui o comprovante</b>. </div>
                      </template>

                      <v-row v-if="donor.PaymentMethod.Id != 1 && donor.PaymentMethod.Id != 4">
                        <v-col cols="12">
                          <InputDate v-model="donor.DepositDate" :label="'Data do depósito'" :minDate="lastYear()"
                            :maxDate="today()" :rules="[validateDepositDate]" required :disabled="savingDonor" />
                        </v-col>
                        <v-col cols="12">
                          <v-file-input accept=".png, .jpg, .jpeg, .bmp, .pdf" v-model="donor.DepositFile"
                            label="Enviar comprovante de pagamento" outlined hide-details="auto"
                            prepend-icon="fal fa-paperclip" :rules="[validateDonorReceipt]" required></v-file-input>
                        </v-col>
                      </v-row>
                      <!--
                      <v-row v-if="donor.PaymentMethod.Id">
                        <v-col>
                          <img v-if="pix.QRCode"
                            :src="'https://benfeitores-back-homolog.azurewebsites.net/api/General/GenerateQRCode?text=' + pix.QRCode"
                            height="250" width="250" />
                          <v-btn v-else color="primary" @click="generateQRCodePix()">Gerar QR Code</v-btn>

                          <v-textarea disabled :value="pix.QRCode" label="PIX copia e cola" rows="4"
                            auto-grow></v-textarea>
                        </v-col>
                        <v-col v-if="pixOk"
                          style="padding-top:15%; position: absolute;width: 90%; height: 30%;text-align: center;background-color: #ffffffee;">
                          <v-icon class="mr-3" color="success" style="font-size: 70px;">fal fa-check-circle</v-icon>
                        </v-col>
                      </v-row>
                    -->
                    </v-card-text>
                  </template>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-container>

        <div v-if="step == 3">

          <template v-if="!donor.completed">
            <v-row>
              <v-col cols="12" class="text-center">
                <h4>
                  Estamos processando sua doação, aguarde um instante por favor, sua doação é muito importante para nós.
                </h4>
              </v-col>
            </v-row>
          </template>

          <template v-else>
            <v-row>
              <v-col cols="12" class="text-center">
                <h4>Muito obrigado por sua doação. <br> Você receberá a confirmação por e-mail. Para doações via DOC,
                  TED, transferência PIX ou boleto seu recibo chegará por e-mail.</h4>
              </v-col>
            </v-row>
            <v-row v-if="donor.result.billet != null">
              <v-col cols="12" lg="12" class="mb-0">
                <label>Copie o código do boleto</label>
                <v-text-field v-model="donor.result.billet.barCode" outlined readonly
                  :hide-details="donor.result.billet.barCode"></v-text-field>

                <div>
                  <b>Data de vencimento: </b> {{ formatterHelper.formatDate(donor.result.billet.dueDate) }}
                </div>
                <br>
              </v-col>
            </v-row>
          </template>

        </div>

      </v-card-text>
      <v-divider class="lg" v-if="step < 3 || !savingDonor"></v-divider>
      <v-card-actions class="px-6 py-5">
        <template v-if="step == 1">
          <v-btn v-if="1 == 2" class="px-6" text rounded large color="primary" @click="$emit('showLogin')">Faça o login
            ou cadastre-se
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="px-12" rounded depressed large color="primary" @click="step = 2"
            :disabled="!isDonorInformationValid">Continuar Doação
          </v-btn>
        </template>

        <template v-if="step == 2">
          <v-btn rounded large depressed outlined class="px-12 gray" @click="step = 1">Voltar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="donor.PaymentMethod.Id == 3" rounded depressed large color="primary" class="px-12"
            @click="createDonation()" :disabled="!isDonorInformationValid">Concluir Doação
          </v-btn>
          <v-btn v-if="donor.PaymentMethod.Id != 3" rounded depressed large color="primary" class="px-12"
            @click="showBilletDialog = true" :disabled="!isDonorInformationValid || showBilletDialog">Avançar
          </v-btn>
        </template>
        <template v-if="donor.completed">
          <v-btn v-if="donor.result.billet != null" rounded depressed large color="success" class="px-12"
            @click="download()"> Baixar Boleto
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn rounded depressed large color="primary" class="px-12" @click="newDonation()">Nova doação
          </v-btn>
        </template>

      </v-card-actions>
    </v-card>

    <!--    botao de login-->
    <v-container style="max-width: 480px;">
      <v-row>
        <v-col cols="12" class="text-center">
          <h6 text large rounded color="primary">
            Para doações em nome de Empresa ou de terceiros, <u role="button" @click="$emit('showLogin')"
              class="primary--text" style="font-size: 18px;">clique aqui!</u>
          </h6>
        </v-col>
      </v-row>
    </v-container>
    <!--    Geração de boleto-->
    <template>
      <v-dialog v-model="showBilletDialog" scrollable persistent max-width="490">
        <v-card>
          <v-card-title>
            Preencha os dados de endereço para completar o seu cadastro
          </v-card-title>
          <v-card-text>
            <v-form ref="donorAddressForm" v-model="isAddressInformationValid">
              <v-row>
                <v-col cols="12">
                  <v-text-field v-mask="'#####-###'" v-model="donor.Address.PostalCode" label="CEP" outlined
                    hide-details="auto" required :rules="[validateNewAgentPostalCode]" :disabled="savingDonor"
                    @blur="getAddressByCEP"></v-text-field>
                </v-col>
                <v-col cols="8">
                  <v-text-field v-model="donor.Address.Street" label="Logradouro" outlined hide-details="auto" required
                    :rules="[validateNewAgentStreet]" :disabled="savingDonor"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model="donor.Address.Number" type="number" label="Número" outlined hide-details="auto"
                    required :rules="[validateNewAgentNumber]" :disabled="savingDonor"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="donor.Address.Complement" label="Complemento" outlined hide-details="auto"
                    :disabled="savingDonor"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="donor.Address.Neighborhood" label="Bairro" outlined hide-details="auto"
                    required :rules="[validateNewAgentNeighborhood]" :disabled="savingDonor"></v-text-field>
                </v-col>
                <v-col cols="8">
                  <v-text-field v-model="donor.Address.City" label="Cidade" outlined hide-details="auto" required
                    :rules="[validateNewAgentCity]" :disabled="savingDonor"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-combobox v-model="donor.Address.State" :items="stateList" item-text="shortName" label="Estado"
                    outlined hide-details="auto" required :rules="[validateNewAgentState]"
                    :disabled="savingDonor"></v-combobox>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-divider class="lg"></v-divider>
          <v-card-actions class="px-6 py-5">
            <v-skeleton-loader :boilerplate="false" type="button" :tile="false" class="mx-auto"
              v-show="savingDonor"></v-skeleton-loader>
            <v-btn rounded large depressed outlined class="px-12 gray" @click="showBilletDialog = false"
              v-show="!savingDonor">Voltar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" rounded large depressed class="px-12" :disabled="!isAddressInformationValid"
              @click="concludeDonation()" v-show="!savingDonor">Concluir</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <v-dialog v-model="showPixPayment" scrollable persistent max-width="490">
      <v-card>
        <v-card-title>
          <h5 class="pt-5 pb-7">Pagamento via PIX</h5>
        </v-card-title>
        <v-card-text class="text--primary">
          <!--div>Copie o código do PIX e faça o pagamento, depois clique em "Concluir doação".</div>
          <br />
          <v-textarea disabled :value="pix.QRCode" label="PIX copia e cola" rows="4" auto-grow></v-textarea-->

          <v-row v-if="donor.PaymentMethod.Id">
            <v-col>
              <div style="text-align: center;">
                <img v-if="pix.QRCode"
                  :src="'https://benfeitores-back-homolog.azurewebsites.net/api/General/GenerateQRCode?text=' + pix.QRCode"
                  height="250" width="250" />
              </div>


              <p>Copie o código do PIX e faça o pagamento, depois clique em "Concluir doação".</p>
              <v-textarea disabled :value="pix.QRCode" label="PIX copia e cola" rows="4" auto-grow></v-textarea>
            </v-col>
            <v-col v-if="pixOk"
              style="padding-top:15%; position: absolute;width: 90%; height: 30%;text-align: center;background-color: #ffffffee;">
              <v-icon class="mr-3" color="success" style="font-size: 70px;">fal fa-check-circle</v-icon>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions class="px-6 py-5">
          <v-spacer></v-spacer>
          <v-btn color="primary" text depressed large @click="pixConcludeDonation()">Concluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Copyright -->
    <div class="copyright mt-5" v-if="0">
      Copyright ©2020 - Benfeitores®.
      <br />Todos os direitos reservados
    </div>

    <!-- Dialog with fail message -->
    <template>
      <v-dialog v-model="showDonationFailMessage" persistent max-width="490">
        <v-card>
          <v-card-title>
            <h5 class="pt-5 pb-7">Deu Erro</h5>
          </v-card-title>
          <v-card-text>Ops! Deu erro, infelizmente tivemos problemas ao efetuar sua doação, verifique se todos os campos
            estão preenchidos corretamente e tente novamente por favor.
          </v-card-text>
          <v-card-actions class="px-6 py-5">
            <v-spacer></v-spacer>
            <v-btn color="gray" text depressed large @click="showDonationFailMessage = false">Entendi
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <!-- End of Dialog with sucess message -->
  </div>
</template>

<script>

import Routes from "@/router/names";
import AuthService from "@/scripts/services/auth.service";
import GeneralService from "@/scripts/services/general.service";
import { mapGetters, mapActions } from "vuex";
import CommonHelper from "@/scripts/helpers/common.helper";
import Logo from "@/components/Logo";
import InputDueDate from "@/components/InputDueDate";
import EntityService from "@/scripts/services/entity.service";
import DonationGroup from "@/scripts/models/donations/donationGroup.model";
import DonationService from "@/scripts/services/donation.service";
import FormatterHelper from "@/scripts/helpers/formatter.helper";
import cep from 'cep-promise';

export default {
  name: "DonationPF",
  components: {
    Logo,
    InputDueDate
  },
  data: () => ({
    formatterHelper: FormatterHelper,
    loading: false,
    step: 1,
    isStepValid: false,
    routes: Routes,
    showRegisterCardPassword: false,
    showInvalidUsernameAndPasswordMessage: false,
    showBilletDialog: false,
    showPixPayment: false,
    authService: new AuthService(),
    generalService: new GeneralService(),
    entityService: new EntityService(),
    donationService: new DonationService(),
    councilName: '',
    //Register Agent Information
    isAddressInformationValid: false,
    isDonorInformationValid: false,
    donor: {
      Document: "",
      FullName: "",
      Email: "",
      Phone: "",
      PaymentMethod: "",
      Amount: "",
      DepositDate: "",
      DepositFile: null,
      DueDate: null,
      Address: {
        GoogleAddress: "",
        PostalCode: "",
        Street: "",
        Number: "",
        Complement: "",
        Neighborhood: "",
        City: "",
        State: ""
      },
      Institution: "",
      completed: false,
      result: null
    },
    pix: {
      QRCode: "",
      txid: ""
    },
    pixOk: false,
    //Lists
    paymentMethods: [
      { Id: 1, Name: "Boleto Bancário" },
      { Id: 2, Name: "Transferência Bancária (TED, DOC, PIX) - Enviar comprovante" },
      { Id: 3, Name: "Doação direta na declaração - Enviar recolhimento do DARF" },

    ],

    stateList: [],
    institutions: [],

    //auxiliar variables
    showDonationFailMessage: false,
    savingDonor: false,
    showCreateAgentSucessMessage: false,
    council: null,
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "",
      suffix: "",
      precision: 2
    },
    endDateMin: new Date(),
    endDateMax: new Date().getFullYear() == 2023 ? new Date(2023, 11, 28) : new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
  }),
  watch: {
    "donor.PaymentMethod": {
      handler: function (val) {
        this.setPaymentMethod(val)
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["getCouncilImage", "getCouncilId"]),
    paymentMethodSelected() {
      let paymentMethodId = this.donor.PaymentMethod.Id;
      return this.paymentMethods.filter(function (e) {
        return e.Id == paymentMethodId
      })[0].Name;
    }
  },
  created() {



    if (localStorage.getItem("pix")) {
      this.paymentMethods.push({ Id: 4, Name: "PIX" })
    }
    //this.getCouncil();
    this.entityService.getCouncilById(this.getCouncilId).then(data => (this.council = data))
    this.generalService.listAllStates().then(result => (this.stateList = result));
    this.donationService.listAllInstitutionsByCurrentCouncil().then(data => (this.institutions = data))
    this.endDateMin = this.tomorrow();
    this.donor.DueDate = new Date().getFullYear() == 2023 ? (new Date().getDate() <= 28 ? new Date(2023, 11, 28) : '') : new Date(this.today().setDate(this.today().getDate() + 7));
    //this.getInstitutions();
  },
  methods: {
    ...mapActions(["setPaymentMethod"]),
    getAddressByCEP() {
      cep(this.donor.Address.PostalCode).then((response) => {
        this.donor.Address.Street = response.street
        this.donor.Address.Neighborhood = response.neighborhood
        this.donor.Address.City = response.city
        this.donor.Address.State = response.state
      });
    },
    getDonationGroup() {
      let donation = {
        donationValue: this.getDonationValueNumber(),
        isAnonymous: false,
        isDARF: this.donor.PaymentMethod.Id == 3,
        isPIX: this.donor.PaymentMethod.Id == 4,
        donationEmails: [],
        donationFrom: {
          Document: this.donor.Document,
          FullName: this.donor.FullName,
          Phone: this.donor.Phone,
          IsCompany: false,
          Email: this.donor.Email,
          SocialReason: null,
          CreationDate: null,
          AddressViewModel: this.donor.Address
        },
        dueDate: this.donor.DueDate, //data de vencimento do boleto
        paymentMethod: this.donor.PaymentMethod.Id >= 2 ? 2 : 1, //nao existe o tipo de pagamento darf, na base ele é apenas um booleano
        depositDate: this.donor.DepositDate,
        transactionId: this.donor.PaymentMethod.Id == 4 ? this.pix.txid : ""
      }

      let donationGroup = new DonationGroup();
      donationGroup.donationToId = this.donor.Institution.id;
      donationGroup.donations.push(donation);
      return donationGroup;
    },
    concludeDonation() {
      console.log("concludeDonation:", this.donor, this.pix)
      if (this.donor.PaymentMethod.Id == 4 && !this.pix.QRCode) {
        this.generateQRCodePix().then(() => {
          this.showPixPayment = true;
        });
      }

      this.createDonation()
    },
    pixConcludeDonation() {
      this.showPixPayment = false;
    },
    createDonation() {
      this.savingDonor = true;
      this.showBilletDialog = false;
      this.donor.completed = false;
      this.step = 3;

      if (this.donor.PaymentMethod.Id == 4) {
        fetch(this.pix.QRCode)
          .then(response => response.blob())
          .then(file => {
            console.log("fetch.this.donationService");
            this.donationService
              .createDonationWithoutLogin(this.getDonationGroup(), file)
              .then(this.callbackDonation)
              .catch(this.callbackDonationError)
              .finally(() => (this.savingDonor = false));
          })
      } else {
        let file = this.donor.DepositFile;

        this.donationService
          .createDonationWithoutLogin(this.getDonationGroup(), file)
          .then(this.callbackDonation)
          .catch(this.callbackDonationError)
          .finally(() => (this.savingDonor = false));
      }
    },
    generateQRCodePix() {
      return new Promise((resolve, reject) => {
        this.donationService.createPixKey(this.getDonationGroup())
          .then(data => {
            console.log("res:", data);
            this.pix.QRCode = data.pixCopiaECola;
            this.pix.txid = data.txid;
            this.verifyPix(this.pix.txid);
            resolve(data);
          })
          .catch(err => {
            this.showDonationFailMessage = true;
            console.log(err);
            reject(err);
          });
      });
      /*this.donationService.createPixKey(this.getDonationGroup()).then(data => {
        console.log("res:", data);
        this.pix.QRCode = data.pixCopiaECola;
        this.pix.txid = data.txid;
        this.verifyPix(this.pix.txid);

      }).catch(err => {
        this.showDonationFailMessage = true;
        console.log(err);
      });*/
    },
    verifyPix(txid) {
      this.donationService.verifyPix(txid).then(data => {
        console.log("this.donationService.verifyPix.res:", data);
        if (data) {
          this.pixOk = true;
        } else {
          setTimeout(() => {
            this.verifyPix(txid);
          }, 4000);
        }
      }).catch(err => {
        this.showDonationFailMessage = true;
        console.log(err);
      });
    },
    callbackDonation(data) {
      this.donor.result = data;
      this.donor.completed = true;
    },
    callbackDonationError(error) {
      this.step = 2;
      this.showDonationFailMessage = true;
      console.log(error);
    },
    newDonation() {
      this.step = 1;
      this.donor.completed = false;
      this.donor.result = null;
      this.donor.DepositDate = "";
      this.donor.DepositFile = null;
      this.donor.Institution = "";
      this.donor.Amount = ""
    },
    download() {
      const donationBilletId = this.donor.result.billet.id;
      const url = process.env.VUE_APP_API_URL + "/Donation/DownloadBillet/?donationBilletId=" + donationBilletId;
      const link = document.createElement("a");
      link.id = "download";
      link.href = url;
      link.download;
      link.click();
    },

    //util
    today() {
      return new Date();
    },
    tomorrow() {
      return new Date(this.today().setDate(this.today().getDate() + 1));
    },
    oneYearFromNow() {
      return new Date(this.today().setFullYear(this.today().getFullYear() + 1));
    },
    InitialTransferPeriod() {
      return new Date(this.today().setMonth(this.today().getMonth() - 3));
    },
    thisYear() {
      return new Date(new Date().getFullYear(), 0, 1)
    },
    lastYear() {
      return new Date(new Date().getFullYear() - 1, 0, 1)
    },
    getDonationValueNumber() {
      if (
        this.donor.Amount instanceof String ||
        typeof this.donor.Amount === "string"
      )
        return parseInt(this.donor.Amount.replace(/\D/g, ""));
      else if (this.donor.Amount instanceof Number) return this.donor.Amount;
      return 0;
    },
    placechanged(formattedPlace) {
      this.donor.Address.PostalCode = formattedPlace.postalCode || "";
      this.donor.Address.Street = formattedPlace.street || "";
      this.donor.Address.Number = formattedPlace.number || "";
      this.donor.Address.Neighborhood = formattedPlace.neighborhood || "";
      this.donor.Address.City = formattedPlace.city || "";
      this.donor.Address.State = formattedPlace.state || "";
    },

    //validations
    validateDonorDocument() {
      if (!this.donor.Document) return "Preencha o documento";
      if (!CommonHelper.validateCPF(this.donor.Document)) return "CPF inválido";
      return true;
    },
    validateDonorFullName() {
      if (!this.donor.FullName)
        return "Preencha o nome";

      if (CommonHelper.wordCount(this.donor.FullName) < 2)
        return "Informe seu Nome completo";

      return true;
    },
    validatePhone() {
      if (!this.donor.Phone) return "Preencha o celular";
      if (!CommonHelper.validateCellPhone(this.donor.Phone))
        return "Celular Inválido";
      return true;
    },
    validateDonorEmail() {
      if (!this.donor.Email) return "Preencha o e-mail";
      if (!CommonHelper.validateEmail(this.donor.Email))
        return "E-mail inválido";
      return true;
    },
    validateDonorPaymentMethod() {
      if (!this.donor.PaymentMethod) return "Selecione um método de pagamento";
      return true;
    },
    validateDonorAmount() {
      if (this.getDonationValueNumber() > 0) {
        return true;
      }
      return "Digite um valor maior que zero";
    },
    validateDonorReceipt() {
      if (this.donor.PaymentMethod.Id != 1 && this.donor.DepositFile == null) return "Anexe o comprovante";
      return true;
    },
    validateNewAgentGoogleAddress() {
      if (!this.donor.Address.GoogleAddress) return "Preencha o endereço";
      return true;
    },
    validateNewAgentPostalCode() {
      if (!this.donor.Address.PostalCode) return "Preencha o CEP";
      return true;
    },
    validateNewAgentStreet() {
      if (!this.donor.Address.Street) return "Preencha o logradouro";
      return true;
    },
    validateNewAgentNumber() {
      if (!this.donor.Address.Number) return "Preencha o número";
      return true;
    },
    validateNewAgentNeighborhood() {
      if (!this.donor.Address.Neighborhood) return "Preencha o bairro";
      return true;
    },
    validateNewAgentCity() {
      if (!this.donor.Address.City) return "Preencha a cidade";
      return true;
    },
    validateNewAgentState() {
      if (!this.donor.Address.State) return "Preencha o estado";
      return true;
    },
    validateDepositDate() {
      if (!this.donor.DepositDate) return "Preencha da data de depósito";
      return true;
    },
    validateDueDate() {
      if (!this.donor.DueDate) return "Preencha da data de vencimento";
      return true;
    },
    validateInstitution() {
      if (!this.donor.Institution) return "Selecione a instituição que deseja doar";
      return true;
    },
    captchaVerified(result) {
      return result;
    }
  }
}
</script>

<style scoped></style>